import React, { useContext } from "react";
import { AppContext } from "../../components/States/AppContext";
import { Link } from "react-router-dom";

//styles
import { ImgPvc } from './PVC.elements';

//images
import pvc from "../../img/numeric/pvc/pvc.png";

const PVC = () => {
  const { state, setState } = useContext(AppContext);

  return (
      <Link to="/settings/arrhythmia">
        {!state.ecg ? <ImgPvc src={pvc} style={{opacity:"0"}} /> : <ImgPvc src={pvc} />}
        
      </Link>
  )
}

export default PVC